export const getSiteUrl = (): string => `${process.env.SITE_URL}/`;
